import { PersistentStore } from "bi-lib";

export const dialogSecondaryActionStore = new PersistentStore<"basic" | "action">("dialogSecondaryAction", "basic");
